const Currency = {
  USD: "usd",
  CAD: "cad",
};

export default Currency;
